import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enAccount from '@/locales/en/account.json'
import enAbout from '@/locales/en/about.json'
import enEvents from '@/locales/en/events.json'
import enAdmin from '@/locales/en/admin.json'
import enArchitecture from '@/locales/en/architecture.json'
import enCommon from '@/locales/en/common.json'
import enCompetitionRequests from '@/locales/en/competition-requests.json'
import enDataPolicy from '@/locales/en/data-policy.json'
import enForms from '@/locales/en/forms.json'
import enGuideAdmin from '@/locales/en/guide-admin.json'
import enGuideJudge from '@/locales/en/guide-judge.json'
import enGuideOrganizer from '@/locales/en/guide-organizer.json'
import enGuideStudent from '@/locales/en/guide-student.json'
import enHelp from '@/locales/en/help.json'
import enHelpJudgeAcceptInvitation from '@/locales/en/help-judge-accept-invitation.json'
import enHelpJudgeDeclareConflictOfInterest from '@/locales/en/help-judge-declare-conflict-of-interest.json'
import enHelpJudgeScoreSubmissionFailed from '@/locales/en/help-judge-score-submission-failed.json'
import enHelpJudgeSubmitScore from '@/locales/en/help-judge-submit-score.json'
import enHelpJudgeViewAssignments from '@/locales/en/help-judge-view-assignments.json'
import enHelpJudgeProfileAndHistory from '@/locales/en/help-judge-profile-and-history.json'
import enHelpJudgeDeclineOrWithdraw from '@/locales/en/help-judge-decline-or-withdraw.json'
import enHelpOrganizerAutoDistribute from '@/locales/en/help-organizer-auto-distribute.json'
import enHelpOrganizerAssignSubmissions from '@/locales/en/help-organizer-assign-submissions.json'
import enHelpOrganizerInviteJudge from '@/locales/en/help-organizer-invite-judge.json'
import enHelpOrganizerEligibilityDataPage from '@/locales/en/help-organizer-eligibility-data-page.json'
import enHelpOrganizerExportCenter from '@/locales/en/help-organizer-export-center.json'
import enHelpOrganizerJudgingLoadCoiTroubleshooting from '@/locales/en/help-organizer-judging-load-coi-troubleshooting.json'
import enHelpOrganizerJudgingLoadPage from '@/locales/en/help-organizer-judging-load-page.json'
import enHelpOrganizerManageSubmissions from '@/locales/en/help-organizer-manage-submissions.json'
import enHelpOrganizerOperationsDashboard from '@/locales/en/help-organizer-operations-dashboard.json'
import enHelpOrganizerParticipantsPage from '@/locales/en/help-organizer-participants-page.json'
import enHelpOrganizerPublishResults from '@/locales/en/help-organizer-publish-results.json'
import enHelpStudentRegistrationNeedsUpdate from '@/locales/en/help-student-registration-needs-update.json'
import enHelpOrganizerManageAnnouncements from '@/locales/en/help-organizer-manage-announcements.json'
import enHelpOrganizerRegistrationReminders from '@/locales/en/help-organizer-registration-reminders.json'
import enHelpOrganizerNotificationEmails from '@/locales/en/help-organizer-notification-emails.json'
import enHelpOrganizerRegistrationDataPage from '@/locales/en/help-organizer-registration-data-page.json'
import enHelpOrganizerReopenScore from '@/locales/en/help-organizer-reopen-score.json'
import enHelpOrganizerRequestNewCompetition from '@/locales/en/help-organizer-request-new-competition.json'
import enHelpOrganizerReviewEligibility from '@/locales/en/help-organizer-review-eligibility.json'
import enHelpPlatformAdminDashboard from '@/locales/en/help-platform-admin-dashboard.json'
import enHelpPlatformAdminManageAdministrators from '@/locales/en/help-platform-admin-manage-administrators.json'
import enHelpPlatformAdminUserManagement from '@/locales/en/help-platform-admin-user-management.json'
import enHelpReferenceStatuses from '@/locales/en/help-reference-statuses.json'
import enHelpStudentCreateJoinTeam from '@/locales/en/help-student-create-join-team.json'
import enHelpStudentFillRegistrationForm from '@/locales/en/help-student-fill-registration-form.json'
import enHelpStudentFinalSubmit from '@/locales/en/help-student-final-submit.json'
import enHelpStudentSubmissionFailed from '@/locales/en/help-student-submission-failed.json'
import enHelpOrganizerBuildForms from '@/locales/en/help-organizer-build-forms.json'
import enHelpOrganizerConfigureCategories from '@/locales/en/help-organizer-configure-categories.json'
import enHelpOrganizerConfigureRoundSchedule from '@/locales/en/help-organizer-configure-round-schedule.json'
import enHelpOrganizerAdvanceTeams from '@/locales/en/help-organizer-advance-teams.json'
import enHelpOrganizerCreateRubric from '@/locales/en/help-organizer-create-rubric.json'
import enHelpOrganizerPreLaunchChecklist from '@/locales/en/help-organizer-pre-launch-checklist.json'
import enHelpOrganizerViewScores from '@/locales/en/help-organizer-view-scores.json'
import enHelpOrganizerManualScoring from '@/locales/en/help-organizer-manual-scoring.json'
import enHelpReferenceEventsOverview from '@/locales/en/help-reference-events-overview.json'
import enHelpStudentBookEventShuttle from '@/locales/en/help-student-book-event-shuttle.json'
import enHelpStudentEventMealsAndHelpDesk from '@/locales/en/help-student-event-meals-and-help-desk.json'
import enHelpStudentEventShuttleBookingFailed from '@/locales/en/help-student-event-shuttle-booking-failed.json'
import enHelpOrganizerEventDayCheckIn from '@/locales/en/help-organizer-event-day-check-in.json'
import enHelpOrganizerEventConsoleAndMembers from '@/locales/en/help-organizer-event-console-and-members.json'
import enHelpPlatformAdminAudit from '@/locales/en/help-platform-admin-audit.json'
import enHelpPlatformAdminReviewCompetitionRequests from '@/locales/en/help-platform-admin-review-competition-requests.json'
import enHelpStudentCreateAccountAndVerifyEmail from '@/locales/en/help-student-create-account-and-verify-email.json'
import enHelpStudentUploadAndMarkReady from '@/locales/en/help-student-upload-and-mark-ready.json'
import enHelpStudentUploadEligibilityProof from '@/locales/en/help-student-upload-eligibility-proof.json'
import enHelpStudentEligibilityProofRejected from '@/locales/en/help-student-eligibility-proof-rejected.json'
import enHelpStudentGettingStarted from '@/locales/en/help-student-getting-started.json'
import enHelpOrganizerGettingStarted from '@/locales/en/help-organizer-getting-started.json'
import enHelpJudgeGettingStarted from '@/locales/en/help-judge-getting-started.json'
import enHelpPlatformAdminGettingStarted from '@/locales/en/help-platform-admin-getting-started.json'
import enHome from '@/locales/en/home.json'
import enHowto from '@/locales/en/howto.json'
import enJudge from '@/locales/en/judge.json'
import enNav from '@/locales/en/nav.json'
import enPlatform from '@/locales/en/platform.json'
import enPrivacy from '@/locales/en/privacy.json'
import enPublic from '@/locales/en/public.json'
import enRubrics from '@/locales/en/rubrics.json'
import enScoring from '@/locales/en/scoring.json'
import enStudent from '@/locales/en/student.json'
import enSubmissions from '@/locales/en/submissions.json'
import enTeams from '@/locales/en/teams.json'
import enTerms from '@/locales/en/terms.json'
import enTrust from '@/locales/en/trust.json'
import zhAccount from '@/locales/zh-TW/account.json'
import zhAbout from '@/locales/zh-TW/about.json'
import zhEvents from '@/locales/zh-TW/events.json'
import zhAdmin from '@/locales/zh-TW/admin.json'
import zhArchitecture from '@/locales/zh-TW/architecture.json'
import zhCommon from '@/locales/zh-TW/common.json'
import zhCompetitionRequests from '@/locales/zh-TW/competition-requests.json'
import zhDataPolicy from '@/locales/zh-TW/data-policy.json'
import zhForms from '@/locales/zh-TW/forms.json'
import zhGuideAdmin from '@/locales/zh-TW/guide-admin.json'
import zhGuideJudge from '@/locales/zh-TW/guide-judge.json'
import zhGuideOrganizer from '@/locales/zh-TW/guide-organizer.json'
import zhGuideStudent from '@/locales/zh-TW/guide-student.json'
import zhHelp from '@/locales/zh-TW/help.json'
import zhHelpJudgeAcceptInvitation from '@/locales/zh-TW/help-judge-accept-invitation.json'
import zhHelpJudgeDeclareConflictOfInterest from '@/locales/zh-TW/help-judge-declare-conflict-of-interest.json'
import zhHelpJudgeScoreSubmissionFailed from '@/locales/zh-TW/help-judge-score-submission-failed.json'
import zhHelpJudgeSubmitScore from '@/locales/zh-TW/help-judge-submit-score.json'
import zhHelpJudgeViewAssignments from '@/locales/zh-TW/help-judge-view-assignments.json'
import zhHelpJudgeProfileAndHistory from '@/locales/zh-TW/help-judge-profile-and-history.json'
import zhHelpJudgeDeclineOrWithdraw from '@/locales/zh-TW/help-judge-decline-or-withdraw.json'
import zhHelpOrganizerAutoDistribute from '@/locales/zh-TW/help-organizer-auto-distribute.json'
import zhHelpOrganizerAssignSubmissions from '@/locales/zh-TW/help-organizer-assign-submissions.json'
import zhHelpOrganizerInviteJudge from '@/locales/zh-TW/help-organizer-invite-judge.json'
import zhHelpOrganizerEligibilityDataPage from '@/locales/zh-TW/help-organizer-eligibility-data-page.json'
import zhHelpOrganizerExportCenter from '@/locales/zh-TW/help-organizer-export-center.json'
import zhHelpOrganizerJudgingLoadCoiTroubleshooting from '@/locales/zh-TW/help-organizer-judging-load-coi-troubleshooting.json'
import zhHelpOrganizerJudgingLoadPage from '@/locales/zh-TW/help-organizer-judging-load-page.json'
import zhHelpOrganizerManageSubmissions from '@/locales/zh-TW/help-organizer-manage-submissions.json'
import zhHelpOrganizerOperationsDashboard from '@/locales/zh-TW/help-organizer-operations-dashboard.json'
import zhHelpOrganizerParticipantsPage from '@/locales/zh-TW/help-organizer-participants-page.json'
import zhHelpOrganizerPublishResults from '@/locales/zh-TW/help-organizer-publish-results.json'
import zhHelpStudentRegistrationNeedsUpdate from '@/locales/zh-TW/help-student-registration-needs-update.json'
import zhHelpOrganizerManageAnnouncements from '@/locales/zh-TW/help-organizer-manage-announcements.json'
import zhHelpOrganizerRegistrationReminders from '@/locales/zh-TW/help-organizer-registration-reminders.json'
import zhHelpOrganizerNotificationEmails from '@/locales/zh-TW/help-organizer-notification-emails.json'
import zhHelpOrganizerRegistrationDataPage from '@/locales/zh-TW/help-organizer-registration-data-page.json'
import zhHelpOrganizerReopenScore from '@/locales/zh-TW/help-organizer-reopen-score.json'
import zhHelpOrganizerRequestNewCompetition from '@/locales/zh-TW/help-organizer-request-new-competition.json'
import zhHelpOrganizerReviewEligibility from '@/locales/zh-TW/help-organizer-review-eligibility.json'
import zhHelpPlatformAdminDashboard from '@/locales/zh-TW/help-platform-admin-dashboard.json'
import zhHelpPlatformAdminManageAdministrators from '@/locales/zh-TW/help-platform-admin-manage-administrators.json'
import zhHelpPlatformAdminUserManagement from '@/locales/zh-TW/help-platform-admin-user-management.json'
import zhHelpReferenceStatuses from '@/locales/zh-TW/help-reference-statuses.json'
import zhHelpStudentCreateJoinTeam from '@/locales/zh-TW/help-student-create-join-team.json'
import zhHelpStudentFillRegistrationForm from '@/locales/zh-TW/help-student-fill-registration-form.json'
import zhHelpStudentFinalSubmit from '@/locales/zh-TW/help-student-final-submit.json'
import zhHelpStudentSubmissionFailed from '@/locales/zh-TW/help-student-submission-failed.json'
import zhHelpOrganizerBuildForms from '@/locales/zh-TW/help-organizer-build-forms.json'
import zhHelpOrganizerConfigureCategories from '@/locales/zh-TW/help-organizer-configure-categories.json'
import zhHelpOrganizerConfigureRoundSchedule from '@/locales/zh-TW/help-organizer-configure-round-schedule.json'
import zhHelpOrganizerAdvanceTeams from '@/locales/zh-TW/help-organizer-advance-teams.json'
import zhHelpOrganizerCreateRubric from '@/locales/zh-TW/help-organizer-create-rubric.json'
import zhHelpOrganizerPreLaunchChecklist from '@/locales/zh-TW/help-organizer-pre-launch-checklist.json'
import zhHelpOrganizerViewScores from '@/locales/zh-TW/help-organizer-view-scores.json'
import zhHelpOrganizerManualScoring from '@/locales/zh-TW/help-organizer-manual-scoring.json'
import zhHelpReferenceEventsOverview from '@/locales/zh-TW/help-reference-events-overview.json'
import zhHelpStudentBookEventShuttle from '@/locales/zh-TW/help-student-book-event-shuttle.json'
import zhHelpStudentEventMealsAndHelpDesk from '@/locales/zh-TW/help-student-event-meals-and-help-desk.json'
import zhHelpStudentEventShuttleBookingFailed from '@/locales/zh-TW/help-student-event-shuttle-booking-failed.json'
import zhHelpOrganizerEventDayCheckIn from '@/locales/zh-TW/help-organizer-event-day-check-in.json'
import zhHelpOrganizerEventConsoleAndMembers from '@/locales/zh-TW/help-organizer-event-console-and-members.json'
import zhHelpPlatformAdminAudit from '@/locales/zh-TW/help-platform-admin-audit.json'
import zhHelpPlatformAdminReviewCompetitionRequests from '@/locales/zh-TW/help-platform-admin-review-competition-requests.json'
import zhHelpStudentCreateAccountAndVerifyEmail from '@/locales/zh-TW/help-student-create-account-and-verify-email.json'
import zhHelpStudentUploadAndMarkReady from '@/locales/zh-TW/help-student-upload-and-mark-ready.json'
import zhHelpStudentUploadEligibilityProof from '@/locales/zh-TW/help-student-upload-eligibility-proof.json'
import zhHelpStudentEligibilityProofRejected from '@/locales/zh-TW/help-student-eligibility-proof-rejected.json'
import zhHelpStudentGettingStarted from '@/locales/zh-TW/help-student-getting-started.json'
import zhHelpOrganizerGettingStarted from '@/locales/zh-TW/help-organizer-getting-started.json'
import zhHelpJudgeGettingStarted from '@/locales/zh-TW/help-judge-getting-started.json'
import zhHelpPlatformAdminGettingStarted from '@/locales/zh-TW/help-platform-admin-getting-started.json'
import zhHome from '@/locales/zh-TW/home.json'
import zhHowto from '@/locales/zh-TW/howto.json'
import zhJudge from '@/locales/zh-TW/judge.json'
import zhNav from '@/locales/zh-TW/nav.json'
import zhPlatform from '@/locales/zh-TW/platform.json'
import zhPrivacy from '@/locales/zh-TW/privacy.json'
import zhPublic from '@/locales/zh-TW/public.json'
import zhRubrics from '@/locales/zh-TW/rubrics.json'
import zhScoring from '@/locales/zh-TW/scoring.json'
import zhStudent from '@/locales/zh-TW/student.json'
import zhSubmissions from '@/locales/zh-TW/submissions.json'
import zhTeams from '@/locales/zh-TW/teams.json'
import zhTerms from '@/locales/zh-TW/terms.json'
import zhTrust from '@/locales/zh-TW/trust.json'

/** The one and only default. Every fallback chain ends here. */
export const DEFAULT_LOCALE = 'zh-TW'
export const SUPPORTED_LOCALES = ['zh-TW', 'en'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export const LOCALE_STORAGE_KEY = 'napaicp.locale'

const resources = {
  'zh-TW': {
    common: zhCommon,
    nav: zhNav,
    home: zhHome,
    about: zhAbout,
    events: zhEvents,
    architecture: zhArchitecture,
    howto: zhHowto,
    admin: zhAdmin,
    student: zhStudent,
    judge: zhJudge,
    public: zhPublic,
    forms: zhForms,
    teams: zhTeams,
    submissions: zhSubmissions,
    rubrics: zhRubrics,
    scoring: zhScoring,
    platform: zhPlatform,
    account: zhAccount,
    trust: zhTrust,
    privacy: zhPrivacy,
    terms: zhTerms,
    'data-policy': zhDataPolicy,
    'guide-student': zhGuideStudent,
    'guide-judge': zhGuideJudge,
    'guide-organizer': zhGuideOrganizer,
    'guide-admin': zhGuideAdmin,
    'competition-requests': zhCompetitionRequests,
    help: zhHelp,
    'help-student-final-submit': zhHelpStudentFinalSubmit,
    'help-student-submission-failed': zhHelpStudentSubmissionFailed,
    'help-organizer-invite-judge': zhHelpOrganizerInviteJudge,
    'help-organizer-reopen-score': zhHelpOrganizerReopenScore,
    'help-reference-statuses': zhHelpReferenceStatuses,
    'help-student-create-join-team': zhHelpStudentCreateJoinTeam,
    'help-judge-accept-invitation': zhHelpJudgeAcceptInvitation,
    'help-judge-submit-score': zhHelpJudgeSubmitScore,
    'help-organizer-manage-submissions': zhHelpOrganizerManageSubmissions,
    'help-platform-admin-dashboard': zhHelpPlatformAdminDashboard,
    'help-student-fill-registration-form': zhHelpStudentFillRegistrationForm,
    'help-judge-declare-conflict-of-interest': zhHelpJudgeDeclareConflictOfInterest,
    'help-organizer-assign-submissions': zhHelpOrganizerAssignSubmissions,
    'help-organizer-publish-results': zhHelpOrganizerPublishResults,
    'help-platform-admin-manage-administrators': zhHelpPlatformAdminManageAdministrators,
    'help-student-upload-and-mark-ready': zhHelpStudentUploadAndMarkReady,
    'help-judge-view-assignments': zhHelpJudgeViewAssignments,
    'help-judge-profile-and-history': zhHelpJudgeProfileAndHistory,
    'help-judge-decline-or-withdraw': zhHelpJudgeDeclineOrWithdraw,
    'help-organizer-auto-distribute': zhHelpOrganizerAutoDistribute,
    'help-judge-score-submission-failed': zhHelpJudgeScoreSubmissionFailed,
    'help-organizer-request-new-competition': zhHelpOrganizerRequestNewCompetition,
    'help-platform-admin-user-management': zhHelpPlatformAdminUserManagement,
    'help-student-create-account-and-verify-email': zhHelpStudentCreateAccountAndVerifyEmail,
    'help-organizer-configure-round-schedule': zhHelpOrganizerConfigureRoundSchedule,
    'help-organizer-configure-categories': zhHelpOrganizerConfigureCategories,
    'help-organizer-build-forms': zhHelpOrganizerBuildForms,
    'help-organizer-create-rubric': zhHelpOrganizerCreateRubric,
    'help-organizer-view-scores': zhHelpOrganizerViewScores,
    'help-organizer-manual-scoring': zhHelpOrganizerManualScoring,
    'help-reference-events-overview': zhHelpReferenceEventsOverview,
    'help-student-book-event-shuttle': zhHelpStudentBookEventShuttle,
    'help-student-event-meals-and-help-desk': zhHelpStudentEventMealsAndHelpDesk,
    'help-student-event-shuttle-booking-failed': zhHelpStudentEventShuttleBookingFailed,
    'help-organizer-event-day-check-in': zhHelpOrganizerEventDayCheckIn,
    'help-organizer-event-console-and-members': zhHelpOrganizerEventConsoleAndMembers,
    'help-organizer-advance-teams': zhHelpOrganizerAdvanceTeams,
    'help-organizer-pre-launch-checklist': zhHelpOrganizerPreLaunchChecklist,
    'help-platform-admin-review-competition-requests': zhHelpPlatformAdminReviewCompetitionRequests,
    'help-platform-admin-audit': zhHelpPlatformAdminAudit,
    'help-student-upload-eligibility-proof': zhHelpStudentUploadEligibilityProof,
    'help-organizer-review-eligibility': zhHelpOrganizerReviewEligibility,
    'help-student-eligibility-proof-rejected': zhHelpStudentEligibilityProofRejected,
    'help-student-getting-started': zhHelpStudentGettingStarted,
    'help-organizer-getting-started': zhHelpOrganizerGettingStarted,
    'help-judge-getting-started': zhHelpJudgeGettingStarted,
    'help-platform-admin-getting-started': zhHelpPlatformAdminGettingStarted,
    'help-organizer-operations-dashboard': zhHelpOrganizerOperationsDashboard,
    'help-organizer-participants-page': zhHelpOrganizerParticipantsPage,
    'help-student-registration-needs-update': zhHelpStudentRegistrationNeedsUpdate,
    'help-organizer-manage-announcements': zhHelpOrganizerManageAnnouncements,
    'help-organizer-registration-reminders': zhHelpOrganizerRegistrationReminders,
    'help-organizer-notification-emails': zhHelpOrganizerNotificationEmails,
    'help-organizer-registration-data-page': zhHelpOrganizerRegistrationDataPage,
    'help-organizer-eligibility-data-page': zhHelpOrganizerEligibilityDataPage,
    'help-organizer-judging-load-page': zhHelpOrganizerJudgingLoadPage,
    'help-organizer-judging-load-coi-troubleshooting': zhHelpOrganizerJudgingLoadCoiTroubleshooting,
    'help-organizer-export-center': zhHelpOrganizerExportCenter,
  },
  en: {
    common: enCommon,
    nav: enNav,
    home: enHome,
    about: enAbout,
    events: enEvents,
    architecture: enArchitecture,
    howto: enHowto,
    admin: enAdmin,
    student: enStudent,
    judge: enJudge,
    public: enPublic,
    forms: enForms,
    teams: enTeams,
    submissions: enSubmissions,
    rubrics: enRubrics,
    scoring: enScoring,
    platform: enPlatform,
    account: enAccount,
    trust: enTrust,
    privacy: enPrivacy,
    terms: enTerms,
    'data-policy': enDataPolicy,
    'guide-student': enGuideStudent,
    'guide-judge': enGuideJudge,
    'guide-organizer': enGuideOrganizer,
    'guide-admin': enGuideAdmin,
    'competition-requests': enCompetitionRequests,
    help: enHelp,
    'help-student-final-submit': enHelpStudentFinalSubmit,
    'help-student-submission-failed': enHelpStudentSubmissionFailed,
    'help-organizer-invite-judge': enHelpOrganizerInviteJudge,
    'help-organizer-reopen-score': enHelpOrganizerReopenScore,
    'help-reference-statuses': enHelpReferenceStatuses,
    'help-student-create-join-team': enHelpStudentCreateJoinTeam,
    'help-judge-accept-invitation': enHelpJudgeAcceptInvitation,
    'help-judge-submit-score': enHelpJudgeSubmitScore,
    'help-organizer-manage-submissions': enHelpOrganizerManageSubmissions,
    'help-platform-admin-dashboard': enHelpPlatformAdminDashboard,
    'help-student-fill-registration-form': enHelpStudentFillRegistrationForm,
    'help-judge-declare-conflict-of-interest': enHelpJudgeDeclareConflictOfInterest,
    'help-organizer-assign-submissions': enHelpOrganizerAssignSubmissions,
    'help-organizer-publish-results': enHelpOrganizerPublishResults,
    'help-platform-admin-manage-administrators': enHelpPlatformAdminManageAdministrators,
    'help-student-upload-and-mark-ready': enHelpStudentUploadAndMarkReady,
    'help-judge-view-assignments': enHelpJudgeViewAssignments,
    'help-judge-profile-and-history': enHelpJudgeProfileAndHistory,
    'help-judge-decline-or-withdraw': enHelpJudgeDeclineOrWithdraw,
    'help-organizer-auto-distribute': enHelpOrganizerAutoDistribute,
    'help-judge-score-submission-failed': enHelpJudgeScoreSubmissionFailed,
    'help-organizer-request-new-competition': enHelpOrganizerRequestNewCompetition,
    'help-platform-admin-user-management': enHelpPlatformAdminUserManagement,
    'help-student-create-account-and-verify-email': enHelpStudentCreateAccountAndVerifyEmail,
    'help-organizer-configure-round-schedule': enHelpOrganizerConfigureRoundSchedule,
    'help-organizer-configure-categories': enHelpOrganizerConfigureCategories,
    'help-organizer-build-forms': enHelpOrganizerBuildForms,
    'help-organizer-create-rubric': enHelpOrganizerCreateRubric,
    'help-organizer-view-scores': enHelpOrganizerViewScores,
    'help-organizer-manual-scoring': enHelpOrganizerManualScoring,
    'help-reference-events-overview': enHelpReferenceEventsOverview,
    'help-student-book-event-shuttle': enHelpStudentBookEventShuttle,
    'help-student-event-meals-and-help-desk': enHelpStudentEventMealsAndHelpDesk,
    'help-student-event-shuttle-booking-failed': enHelpStudentEventShuttleBookingFailed,
    'help-organizer-event-day-check-in': enHelpOrganizerEventDayCheckIn,
    'help-organizer-event-console-and-members': enHelpOrganizerEventConsoleAndMembers,
    'help-organizer-advance-teams': enHelpOrganizerAdvanceTeams,
    'help-organizer-pre-launch-checklist': enHelpOrganizerPreLaunchChecklist,
    'help-platform-admin-review-competition-requests': enHelpPlatformAdminReviewCompetitionRequests,
    'help-platform-admin-audit': enHelpPlatformAdminAudit,
    'help-student-upload-eligibility-proof': enHelpStudentUploadEligibilityProof,
    'help-organizer-review-eligibility': enHelpOrganizerReviewEligibility,
    'help-student-eligibility-proof-rejected': enHelpStudentEligibilityProofRejected,
    'help-student-getting-started': enHelpStudentGettingStarted,
    'help-organizer-getting-started': enHelpOrganizerGettingStarted,
    'help-judge-getting-started': enHelpJudgeGettingStarted,
    'help-platform-admin-getting-started': enHelpPlatformAdminGettingStarted,
    'help-organizer-operations-dashboard': enHelpOrganizerOperationsDashboard,
    'help-organizer-participants-page': enHelpOrganizerParticipantsPage,
    'help-student-registration-needs-update': enHelpStudentRegistrationNeedsUpdate,
    'help-organizer-manage-announcements': enHelpOrganizerManageAnnouncements,
    'help-organizer-registration-reminders': enHelpOrganizerRegistrationReminders,
    'help-organizer-notification-emails': enHelpOrganizerNotificationEmails,
    'help-organizer-registration-data-page': enHelpOrganizerRegistrationDataPage,
    'help-organizer-eligibility-data-page': enHelpOrganizerEligibilityDataPage,
    'help-organizer-judging-load-page': enHelpOrganizerJudgingLoadPage,
    'help-organizer-judging-load-coi-troubleshooting': enHelpOrganizerJudgingLoadCoiTroubleshooting,
    'help-organizer-export-center': enHelpOrganizerExportCenter,
  },
} as const

export function isSupportedLocale(value: string | null | undefined): value is SupportedLocale {
  return SUPPORTED_LOCALES.includes(value as SupportedLocale)
}

/**
 * Browser locale, matched down to one of our two supported tags. Anything
 * that is not clearly English (e.g. `en`, `en-US`) resolves to zh-TW, which
 * keeps the default honest: this platform is zh-TW first.
 */
function detectBrowserLocale(): SupportedLocale {
  if (typeof navigator === 'undefined') {
    return DEFAULT_LOCALE
  }
  const languages = navigator.languages ?? [navigator.language]
  for (const language of languages) {
    if (language.toLowerCase().startsWith('en')) {
      return 'en'
    }
    if (language.toLowerCase().startsWith('zh')) {
      return 'zh-TW'
    }
  }
  return DEFAULT_LOCALE
}

/**
 * Resolves the locale to boot with, in priority order:
 * 1. A previously persisted choice in localStorage (the language switcher).
 * 2. The signed-in user's stored profile locale, if one was passed in.
 * 3. The browser's own language.
 * 4. zh-TW.
 */
export function resolveInitialLocale(userLocale?: string | null): SupportedLocale {
  if (typeof window !== 'undefined') {
    const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY)
    if (isSupportedLocale(stored)) {
      return stored
    }
  }
  if (isSupportedLocale(userLocale)) {
    return userLocale
  }
  return detectBrowserLocale()
}

export function persistLocale(locale: SupportedLocale): void {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale)
  }
}

/** BCP 47 tags for `<html lang>` — zh-TW's app locale maps to the zh-Hant script tag. */
const HTML_LANG_TAGS: Record<SupportedLocale, string> = {
  'zh-TW': 'zh-Hant',
  en: 'en',
}

/**
 * Keeps `<html lang>` in sync with the active i18n language. Browsers and
 * screen readers read this attribute, not i18next's internal state, so
 * leaving it hardcoded meant switching to English never updated it.
 */
function syncHtmlLang(locale: string): void {
  if (typeof document === 'undefined') {
    return
  }
  document.documentElement.lang = isSupportedLocale(locale) ? HTML_LANG_TAGS[locale] : locale
}

void i18n.use(initReactI18next).init({
  resources,
  lng: resolveInitialLocale(),
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: 'common',
  ns: [
    'common',
    'nav',
    'home',
    'about',
    'events',
    'architecture',
    'howto',
    'admin',
    'student',
    'judge',
    'public',
    'forms',
    'teams',
    'submissions',
    'rubrics',
    'scoring',
    'platform',
    'account',
    'trust',
    'privacy',
    'terms',
    'data-policy',
    'guide-student',
    'guide-judge',
    'guide-organizer',
    'guide-admin',
    'competition-requests',
    'help',
    'help-student-final-submit',
    'help-student-submission-failed',
    'help-organizer-invite-judge',
    'help-organizer-reopen-score',
    'help-reference-statuses',
    'help-student-create-join-team',
    'help-judge-accept-invitation',
    'help-judge-submit-score',
    'help-organizer-manage-submissions',
    'help-platform-admin-dashboard',
    'help-student-fill-registration-form',
    'help-judge-declare-conflict-of-interest',
    'help-organizer-assign-submissions',
    'help-organizer-publish-results',
    'help-platform-admin-manage-administrators',
    'help-student-upload-and-mark-ready',
    'help-judge-view-assignments',
    'help-judge-profile-and-history',
    'help-judge-decline-or-withdraw',
    'help-organizer-auto-distribute',
    'help-judge-score-submission-failed',
    'help-organizer-request-new-competition',
    'help-platform-admin-user-management',
    'help-student-create-account-and-verify-email',
    'help-organizer-configure-round-schedule',
    'help-organizer-configure-categories',
    'help-organizer-build-forms',
    'help-organizer-create-rubric',
    'help-organizer-view-scores',
    'help-organizer-manual-scoring',
    'help-reference-events-overview',
    'help-student-book-event-shuttle',
    'help-student-event-meals-and-help-desk',
    'help-student-event-shuttle-booking-failed',
    'help-organizer-event-day-check-in',
    'help-organizer-event-console-and-members',
    'help-organizer-advance-teams',
    'help-organizer-pre-launch-checklist',
    'help-platform-admin-review-competition-requests',
    'help-platform-admin-audit',
    'help-student-upload-eligibility-proof',
    'help-organizer-review-eligibility',
    'help-student-eligibility-proof-rejected',
    'help-student-getting-started',
    'help-organizer-getting-started',
    'help-judge-getting-started',
    'help-platform-admin-getting-started',
    'help-organizer-operations-dashboard',
    'help-organizer-participants-page',
    'help-student-registration-needs-update',
    'help-organizer-manage-announcements',
    'help-organizer-registration-reminders',
    'help-organizer-notification-emails',
    'help-organizer-registration-data-page',
    'help-organizer-eligibility-data-page',
    'help-organizer-judging-load-page',
    'help-organizer-judging-load-coi-troubleshooting',
    'help-organizer-export-center',
  ],
  interpolation: { escapeValue: false },
  // Never render a raw key: fall back to zh-TW resources for anything
  // missing from the active language, and only fail visibly in dev.
  returnEmptyString: false,
  saveMissing: false,
  react: { useSuspense: false },
})

i18n.on('languageChanged', syncHtmlLang)
syncHtmlLang(i18n.language)

export default i18n
